"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MarkdownViewer = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = require("../Button");

var _utils = require("../utils");

var _withTheme = require("../../wrappers/with-theme");

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _linkifyIt = _interopRequireDefault(require("linkify-it"));

var _tlds = _interopRequireDefault(require("tlds"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var linkify = (0, _linkifyIt["default"])().tlds(_tlds["default"]).add("ftp", null).set({
  fuzzyIP: true
});

var Link = function Link(_ref) {
  var href = _ref.href,
      children = _ref.children;
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: href,
    className: "\n      ".concat(theme.textInfo, " hover:underline\n    ")
  }, children);
};

var Text = function Text(_ref2) {
  var _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? "" : _ref2$value;
  var links = linkify.match(value);
  if (!links) return value;
  var response = [];
  var index = 0;
  links.forEach(function (link) {
    response.push(value.slice(index, link.index));
    response.push( /*#__PURE__*/_react["default"].createElement(Link, {
      key: link.index,
      href: link.url
    }, link.text));
    index = link.lastIndex;
  });
  response.push(value.slice(index));
  return response.filter(Boolean);
};

var Code = function Code(_ref3) {
  var value = _ref3.value,
      rest = _objectWithoutProperties(_ref3, ["value"]);

  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("pre", {
    className: "\n      rounded ".concat(theme.accent1, " px-2 py-1\n      scrollbar overflow-x-auto\n    ")
  }, /*#__PURE__*/_react["default"].createElement(Text, {
    value: value
  }));
};

var BlockQuote = function BlockQuote(_ref4) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("blockquote", {
    className: "\n      rounded ".concat(theme.accent1, " px-2 py-1 whitespace-pre-wrap\n    ")
  }, children);
};

var renderers = {
  heading: function heading(_ref5) {
    var level = _ref5.level,
        children = _ref5.children;
    return level === 1 ? /*#__PURE__*/_react["default"].createElement("h1", {
      className: "font-bold text-3xl"
    }, children) : level === 2 ? /*#__PURE__*/_react["default"].createElement("h2", {
      className: "font-bold text-2xl"
    }, children) : level === 3 ? /*#__PURE__*/_react["default"].createElement("h3", {
      className: "font-bold text-xl"
    }, children) : /*#__PURE__*/_react["default"].createElement("h4", {
      className: "font-bold text-lg"
    }, children);
  },
  list: function list(_ref6) {
    var ordered = _ref6.ordered,
        children = _ref6.children;
    return ordered ? /*#__PURE__*/_react["default"].createElement("ol", {
      className: "list-decimal list-inside"
    }, children) : /*#__PURE__*/_react["default"].createElement("ul", {
      className: "list-disc list-inside"
    }, children);
  },
  code: Code,
  blockquote: BlockQuote,
  paragraph: function paragraph(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "whitespace-pre-wrap"
    }, children);
  },
  text: Text,
  link: Link
};

var MarkdownViewer = function MarkdownViewer(_ref8) {
  var markdown = _ref8.markdown,
      props = _objectWithoutProperties(_ref8, ["markdown"]);

  return /*#__PURE__*/_react["default"].createElement(_reactMarkdown["default"], _extends({
    renderers: renderers
  }, props), markdown);
};

exports.MarkdownViewer = MarkdownViewer;

var _default = /*#__PURE__*/_react["default"].forwardRef(function (_ref9, ref) {
  var large = _ref9.large,
      small = _ref9.small,
      _ref9$className = _ref9.className,
      className = _ref9$className === void 0 ? "" : _ref9$className,
      children = _ref9.children,
      onChange = _ref9.onChange,
      value = _ref9.value,
      autoFocus = _ref9.autoFocus,
      _ref9$disabled = _ref9.disabled,
      disabled = _ref9$disabled === void 0 ? false : _ref9$disabled,
      _ref9$placeholder = _ref9.placeholder,
      placeholder = _ref9$placeholder === void 0 ? "enter some markdown..." : _ref9$placeholder,
      props = _objectWithoutProperties(_ref9, ["large", "small", "className", "children", "onChange", "value", "autoFocus", "disabled", "placeholder"]);

  var _React$useState = _react["default"].useState(!value),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      editing = _React$useState2[0],
      setEditing = _React$useState2[1],
      prevState = _react["default"].useRef(editing),
      prevValue = _react["default"].useRef();

  var handleChange = _react["default"].useCallback(function (e) {
    onChange(e.target.value);
  }, [onChange]);

  var theme = (0, _withTheme.useTheme)(),
      inputTheme = theme["input".concat((0, _utils.composeOptions)({
    large: large,
    small: small
  }))];

  var _React$useState3 = _react["default"].useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      innerRef = _React$useState4[0],
      setInnerRef = _React$useState4[1];

  _react["default"].useEffect(function () {
    if (autoFocus && innerRef) {
      innerRef.focus();
      setEditing(true);
    }
  }, [autoFocus, innerRef]);

  _react["default"].useEffect(function () {
    if (editing && innerRef && prevValue.current !== value) {
      innerRef.style.height = 'auto';
      innerRef.style.height = "calc(".concat(innerRef.scrollHeight, "px + 0.125rem)");
      prevValue.current = value;
    }

    if (editing && !prevState.current) {
      innerRef.focus();
    }

    prevState.current = editing;
  }, [value, editing, innerRef]);

  var clickedOutside = _react["default"].useCallback(function (e) {
    setEditing(!value);
  }, [value]);

  var _useClickOutside = (0, _utils.useClickOutside)(clickedOutside),
      _useClickOutside2 = _slicedToArray(_useClickOutside, 1),
      setNode = _useClickOutside2[0];

  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: setNode,
    className: "relative",
    onDoubleClick: function onDoubleClick(e) {
      return setEditing(true);
    }
  }, !value ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute right-0 top-0 mr-1 mt-1"
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    tabIndex: -1,
    small: true,
    key: editing ? "editing" : "viewing",
    onClick: function onClick(e) {
      return setEditing(function (editing) {
        return !editing;
      });
    }
  }, editing ? "preview" : "edit")), /*#__PURE__*/_react["default"].createElement("textarea", _extends({}, props, {
    rows: 1,
    tabIndex: disabled || !editing ? -1 : 0,
    value: value || "",
    onChange: handleChange,
    style: {
      display: editing ? "block" : "none"
    },
    className: "".concat(inputTheme, " ").concat(className, " resize-none"),
    onFocus: function onFocus(e) {
      return editing && innerRef.focus();
    },
    onBlur: function onBlur(e) {
      return setEditing(!value);
    },
    placeholder: placeholder,
    ref: (0, _utils.useSetRefs)(ref, setInnerRef)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: disabled || editing ? -1 : 0,
    className: "\n          ".concat(inputTheme, " ").concat(className, " ").concat(editing ? "hidden" : "block", "\n        ")
  }, /*#__PURE__*/_react["default"].createElement(_reactMarkdown["default"], {
    renderers: renderers
  }, value)));
});

exports["default"] = _default;